import { axiosService } from "../axios.service";
import { urls } from "../../constants";

const ordersService = {
  getAllOrders: ({
    page,
    word = "",
    startDate = "",
    endDate = "",
    status = [],
    searchField = "orderId",
  }) => {
    const searchKey =
      searchField === "clientName" || searchField === "phoneNumber"
        ? searchField
        : "orderId";
    return axiosService
      .get(`${urls.orders.ordersR}`, {
        params: {
          page,
          [searchKey]: word,
          startDate,
          endDate,
          status,
        },
        paramsSerializer: (params) => {
          const query = new URLSearchParams();
          Object.entries(params).forEach(([key, value]) => {
            if (Array.isArray(value)) {
              value.forEach((val) => query.append(key, val));
            } else {
              query.append(key, value);
            }
          });
          return query.toString();
        },
      })
      .then((value) => value.data);
  },

  getAllMenuDishesForDate: async (data) => {
    return await axiosService.post(urls.orders.menuDishesDate, data);
  },

  createOrder: (data) =>
    axiosService.post(urls.orders.ordersR, data).then((value) => value.data),

  getOrderById: (id) =>
    axiosService
      .get(`${urls.orders.ordersR}/details`, { params: { id } })
      .then((value) => value.data),

  updateDishById: (id, data) =>
    axiosService
      .patch(`${urls.orders.ordersR}/dishes/${id}`, data)
      .then((value) => value.data),

  updateOrderById: (id, data) =>
    axiosService
      .patch(`${urls.orders.ordersR}/${id}`, data)
      .then((value) => value.data),

  updateOrderStatusById: (id, data) =>
    axiosService
      .patch(`${urls.orders.ordersR}/${id}/status`, data)
      .then((value) => value.data),

  getDishesByDate: (productIds, startDate, endDate) =>
    axiosService
      .get(`${urls.orders.ordersR}/dishes-range-by-date`, {
        params: { productIds, startDate, endDate },
      })
      .then((value) => value.data),

  getProductsByDate: (date, params = {}) =>
    axiosService
      .get(`${urls.orders.ordersR}/products/${date}`, { params })
      .then((value) => value.data),

  getProductsByDateRange: (startDate, endDate, params = {}) =>
    axiosService
      .get(`${urls.orders.ordersR}/products-range`, {
        params: { startDate, endDate, ...params },
      })
      .then((value) => value.data),

  getDeliveriesByDate: (date) =>
    axiosService
      .get(`${urls.orders.ordersR}/deliveries/${date}`)
      .then((value) => value.data),

  getDeliveriesByDateRange: (startDate, endDate) =>
    axiosService
      .get(`${urls.orders.ordersR}/deliveries-range-by-date`, {
        params: { startDate, endDate },
      })
      .then((value) => value.data),

  getDeliveryStatistics: () =>
    axiosService
      .get(`${urls.orders.ordersR}/deliveries-statistics`)
      .then((value) => value.data),

  moveToAnotherDate: (data) =>
    axiosService
      .post(`${urls.orders.ordersR}/transfer-dishes`, data)
      .then((value) => value.data),

  deleteMoveOrderToAnotherDate: (id) =>
    axiosService.destroy(`${urls.orders.ordersR}/${id}/cancel-transfer`),

  getHistoryOrderById: (id) =>
    axiosService
      .get(`${urls.orders.ordersR}/${id}/history`)
      .then((value) => value.data),

  getChangelogById: (id) =>
    axiosService
      .get(`${urls.orders.ordersR}/${id}/changelog`)
      .then((value) => value.data),

  checkPromoCode: (code, userId) =>
    axiosService
      .get(`${urls.promoCodes.promoCodesR}/check-promo-code-by-admin`, {
        params: { code, userId },
      })
      .then((value) => value.data),

  // New API methods for checkout flow
  checkPromoWithOrder: (data) =>
    axiosService
      .post(`${urls.promoCodes.promoCodesR}/check-promo-with-order`, data)
      .then((value) => value.data),

  calculatePricing: (data) =>
    axiosService
      .post(`${urls.orders.ordersR}/calculate-pricing`, data)
      .then((value) => value.data),

  calculatePricingWithoutCreatingOrder: (data) =>
    axiosService
      .post(
        `${urls.orders.ordersR}/calculate-pricing-without-creating-order`,
        data,
      )
      .then((value) => value.data),

  payOrder: (orderId) =>
    axiosService
      .post(`/payment/create-checkout-session`, { orderId })
      .then((value) => value.data),

  createPayment: (orderId, data) =>
    axiosService
      .post(`${urls.orders.ordersR}/${orderId}/payments`, data)
      .then((value) => value.data),

  updatePaymentStatus: (orderId, paymentId, data) =>
    axiosService
      .patch(`${urls.orders.ordersR}/${orderId}/payments/${paymentId}`, data)
      .then((value) => value.data),

  resetOrderMeals: (orderId) =>
    axiosService
      .get(`${urls.orders.ordersR}/reset-order-meals`, {
        params: {
          id: orderId,
        },
      })
      .then((value) => value.data),

  getKitchenSheetData: (startDate, endDate) =>
    axiosService
      .get(`${urls.orders.ordersR}/kitchen-sheet-data`, {
        params: {
          startDate,
          endDate,
        },
      })
      .then((value) => value.data),

  deductStorage: (startDate, endDate) =>
    axiosService
      .post(`${urls.orders.ordersR}/deduct-storage`, { startDate, endDate })
      .then((value) => value.data),
};

export { ordersService };
